import { useRestClient } from '@/contexts/QueryProvider'
import { useParams } from 'react-router'
// import { dagsterAppsMockData } from './dagsterAppsMockData'
import { IconBg } from '@/components/ui/IconBg'
import { ApplicationIcon } from '@/const'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { Badge } from '@/components/shadcn/badge'
import { DataTable } from '@/components/ui/DataTable/DataTable'
// import { mockRunsData } from './mockRunsData'
import { dagsterApplicationRunsColumns } from '../DagsterApplicationRunsTable/DagsterApplicationRunsColumns'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { useMemo } from 'react'
import { LogsContent, LogsDialog } from '../DagsterApplicationRunsTable/LogsDialog'

export function DagsterApplicationRunsPage({ appId, projectId }: { appId?: number; projectId?: number }) {
  const { applicationId: appIdParam } = useParams()
  const { getDagsterApiGetDagsterApps, getDagsterApiGetDagsterRuns } = useRestClient()

  const applicationId = appIdParam ? Number(appIdParam) : appId ? appId : undefined

  const { data: dagsterApps } = getDagsterApiGetDagsterApps.useSuspenseQuery(undefined, {
    // select: () => dagsterAppsMockData,
  })
  const dagsterApp = applicationId ? dagsterApps.find((app) => app.applicationId === applicationId) : undefined

  const { data: results } = getDagsterApiGetDagsterRuns.useSuspenseQuery(
    {
      query: { applicationId: applicationId, projectId: projectId },
    },
    {
      select: (data) => data?.data?.runsFeedOrError?.results ?? [],
    }
  )

  const sectionTitle = dagsterApp?.appName ? (
    <div className="flex items-center gap-x-2">
      <div className="flex items-center gap-x-2 rounded-md bg-foreground/5 p-2">
        <IconBg className="bg-foreground/5">
          <ApplicationIcon className="size-4" />
        </IconBg>
        <span className="font-medium">{dagsterApp.appName}</span>
        <Badge
          className="bg-foreground/5 font-medium text-foreground hover:bg-foreground/10 hover:text-foreground"
          variant="secondary"
        >
          {dagsterApp.appKey}
        </Badge>
      </div>
      <span className="text-base text-muted-foreground">Dagster runs</span>
    </div>
  ) : (
    'Application runs'
  )

  const columnsWithLogs = useMemo(() => {
    return applicationId
      ? [
          ...dagsterApplicationRunsColumns,
          {
            id: 'logs',
            header: 'View Logs',
            size: 62,
            cell: ({ row }) => (
              <LogsDialog title="Logs" description="Logs">
                <LogsContent runId={row.original.id!} applicationId={applicationId} />
              </LogsDialog>
            ),
          },
        ]
      : dagsterApplicationRunsColumns
  }, [applicationId])

  return (
    <TablePageContainer>
      <DataTable
        columns={columnsWithLogs}
        // data={mockRunsData.data.runsFeedOrError.results}
        data={results}
        title={sectionTitle}
      />
    </TablePageContainer>
  )
}

export function DagsterApplicationRunsPageLoading() {
  return (
    <TablePageContainer>
      <div className="flex h-full items-center justify-center">
        <LoadingComponent />
      </div>
    </TablePageContainer>
  )
}
